<div #element [innerHTML]="svg" class="svg"></div>